import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      clientsCount: 0,
      clients: [],
      pagination: {
        total: 0, currentPage: 1, lastPage: 1,
        firstItem: 0, lastItem: 0, hasMorePages: false, perPage: 12,
      },
    };
  },
  mutations,
  actions,
  getters,
};
